export class FilterTrackers {
  /**
   * Job Stats
   * */
  static readonly FILTER_APPLY_CTA_CLICK = '[Filters] apply filters cta click';

  static readonly FILTER_CANCEL_CTA_CLICK = '[Filters] cancel cta click';

  static readonly FILTER_CLEAR_ALL_FILTERS_CTA_CLICK = '[Filters] clear all filters cta click';

  static readonly FILTER_OPEN_FILTER_CLICK = '[Filters] open filter cta click';

  static readonly FILTER_SET_FILTER_ONCHANGE = '[Filters] set filter on change';

  static readonly FILTER_CLEAR_FILTER_CTA_CLICK = '[Filters] clear filter cta click';

  static readonly FILTER_CHIP_CLEAR_FILTER_CLICK = '[Filter chip] clear filter cta click';

  static readonly FILTER_CHIP_CLEAR_FILTER_SECTION_CLICK =
    '[Filter chip] clear filter section cta click';

  static readonly FILTER_CHIP_CLEAR_ALL_FILTERS_CTA_CLICK =
    '[Filter chip] clear all filter cta click';
}
